import { render, staticRenderFns } from "./ResourceOfHos.vue?vue&type=template&id=f1ec0860&scoped=true"
import script from "./ResourceOfHos.vue?vue&type=script&lang=js"
export * from "./ResourceOfHos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ec0860",
  null
  
)

export default component.exports